package one.healthium.tasks.data.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class Config(
    @SerialName("colors") val colors: Map<String, String>
)
